export default __webpack_public_path__ + "static/media/interior (4).eb43475c.jpg";